import React from "react";

import { Relative } from "./Position";

export const AspectRatio = ({ children, bg, ratio = 16 / 9, ...props }) => (
  <Relative bg={bg} {...props} style={{ aspectRatio: ratio }}>
    {children}
  </Relative>
);
